import { Folder } from '../folder';

export const hasNoContent = (_: number, _nodeData: Folder) => !_nodeData['name'];
